<template>

</template>

<script>
export default {
  name: "Town",
  components: {

  },
  data() {
    return {

    }
  },
  methods: {
    createData() {

    },
    toDataV() {
      // let href = `http://192.168.100.4:8080`
      let href = `http://datav.jinchanhb.com`
      window.open(href, '_blank');
    }
  },
  mounted() {
    const {toDataV} = this;
    toDataV();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/bigdata/town/index.vue